import { render, staticRenderFns } from "./KullaniciGorevVermeButon.vue?vue&type=template&id=32f421ab"
import script from "./KullaniciGorevVermeButon.vue?vue&type=script&lang=js"
export * from "./KullaniciGorevVermeButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports